export const OPTIONS = "OPTIONS";
export const MAGE_TYPE= "MAGE_TYPE";
export const LOAD_GAMES = "LOAD";
export const LEGAL = "LEGAL";
export const LOCALIZATION = "LOCALIZATION";
export const CREDITS = "CREDITS";
export const MODS = "MODS";
export const HELP = "HELP";
export const ENCYCLOPEIDA = "ENCYCLOPEDIA";
export const PLAY = "PLAY";
export const MULTIPLAYER_SERVER_CHOOSER = "MULTIPLAYER_SERVER_CHOOSER";
export const LANGUAGE = "LANGUAGE";
export const TODO = "TODO";